// extracted by mini-css-extract-plugin
export var locationsContainer = "_z2-2";
export var locationsTextContainer = "_z2-1";
export var mapContainer = "_z2-0";